import type { StrictPost } from '$lib/types'

export const meta: StrictPost = {
	title: 'Email Builder',
	slug: 'email-builder',
	description: 'A web app to help you write an email to a politician. Convince them to Pause AI!',
	date: '2023-12-08',
	categories: []
}
